const rupees = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export function formatRupees(value, fallback = "Not set") {
  if (value === null || value === undefined || String(value).trim() === "") return fallback;
  const amount = Number(value);
  return Number.isFinite(amount) ? rupees.format(amount) : fallback;
}
